import { useState, useEffect } from "react";
import { useJumboDialog } from 'themes/jumbo/@jumbo/components/JumboDialog/hooks/useJumboDialog';

type IProps = {
    open: boolean;
    title: string;
    msg?: string;
    type?: string;
    name?: string;
    confirmAction: (value: any) => void;
};

export default function ConfirmationDialog(props: IProps) {
    const [open, setOpen] = useState(props.open);
    const { title, msg, type, name } = props;
    const { showDialog, hideDialog } = useJumboDialog();

    const handleClose = (status: boolean) => {
        setOpen(false);
        hideDialog();
        props.confirmAction({ name, status });
    };

    const handleCancel = () => {
        handleClose(false);
    };

    const handleOk = () => {
        handleClose(true);
    };

    const onClose = (reason: string) => {};

    useEffect(() => {
        open && showDialog({
            variant: 'confirm',
            title,
            content: msg || `Are you sure you want to delete ${type} '${name}' ?`,
            onYes: () => handleOk(),
            onNo: () => handleCancel(),
        });
    }, [open]);

    return false
}
